// Hard-coded content that should be moved to the DB eventually.
import React from "react"

import { Group, Person } from "@mui/icons-material"
import { LessonType, LessonTypeName } from "@coast/utils"
import { hoursToMinutes } from "./utils/misc"

export const STATES = [
  {
    shortName: "CA",
    longName: "California",
  },
  {
    shortName: "CO",
    longName: "Colorado",
  },
  {
    shortName: "IL",
    longName: "Illinois",
  },
  {
    shortName: "IN",
    longName: "Indiana",
  },
  {
    shortName: "MD",
    longName: "Maryland",
  },
  {
    shortName: "MO",
    longName: "Missouri",
  },
  {
    shortName: "NV",
    longName: "Nevada",
  },
  {
    shortName: "PA",
    longName: "Pennsylvania",
  },
  {
    shortName: "TX",
    longName: "Texas",
  },
  {
    shortName: "WA",
    longName: "Washington",
  },
  {
    shortName: "WI",
    longName: "Wisconsin",
  },
]
export const ALL_STATES = [
  {
    longName: "Alabama",
    shortName: "AL",
  },
  {
    longName: "Alaska",
    shortName: "AK",
  },
  {
    longName: "Arizona",
    shortName: "AZ",
  },
  {
    longName: "Arkansas",
    shortName: "AR",
  },
  {
    longName: "California",
    shortName: "CA",
  },
  {
    longName: "Colorado",
    shortName: "CO",
  },
  {
    longName: "Connecticut",
    shortName: "CT",
  },
  {
    longName: "Delaware",
    shortName: "DE",
  },
  {
    longName: "Florida",
    shortName: "FL",
  },
  {
    longName: "Georgia",
    shortName: "GA",
  },
  {
    longName: "Hawaii",
    shortName: "HI",
  },
  {
    longName: "Idaho",
    shortName: "ID",
  },
  {
    longName: "Illinois",
    shortName: "IL",
  },
  {
    longName: "Indiana",
    shortName: "IN",
  },
  {
    longName: "Iowa",
    shortName: "IA",
  },
  {
    longName: "Kansas",
    shortName: "KS",
  },
  {
    longName: "Kentucky",
    shortName: "KY",
  },
  {
    longName: "Louisiana",
    shortName: "LA",
  },
  {
    longName: "Maine",
    shortName: "ME",
  },
  {
    longName: "Maryland",
    shortName: "MD",
  },
  {
    longName: "Massachusetts",
    shortName: "MA",
  },
  {
    longName: "Michigan",
    shortName: "MI",
  },
  {
    longName: "Minnesota",
    shortName: "MN",
  },
  {
    longName: "Mississippi",
    shortName: "MS",
  },
  {
    longName: "Missouri",
    shortName: "MO",
  },
  {
    longName: "Montana",
    shortName: "MT",
  },
  {
    longName: "Nebraska",
    shortName: "NE",
  },
  {
    longName: "Nevada",
    shortName: "NV",
  },
  {
    longName: "New Hampshire",
    shortName: "NH",
  },
  {
    longName: "New Jersey",
    shortName: "NJ",
  },
  {
    longName: "New Mexico",
    shortName: "NM",
  },
  {
    longName: "New York",
    shortName: "NY",
  },
  {
    longName: "North Carolina",
    shortName: "NC",
  },
  {
    longName: "North Dakota",
    shortName: "ND",
  },
  {
    longName: "Ohio",
    shortName: "OH",
  },
  {
    longName: "Oklahoma",
    shortName: "OK",
  },
  {
    longName: "Oregon",
    shortName: "OR",
  },
  {
    longName: "Pennsylvania",
    shortName: "PA",
  },
  {
    longName: "Rhode Island",
    shortName: "RI",
  },
  {
    longName: "South Carolina",
    shortName: "SC",
  },
  {
    longName: "South Dakota",
    shortName: "SD",
  },
  {
    longName: "Tennessee",
    shortName: "TN",
  },
  {
    longName: "Texas",
    shortName: "TX",
  },
  {
    longName: "Utah",
    shortName: "UT",
  },
  {
    longName: "Vermont",
    shortName: "VT",
  },
  {
    longName: "Virginia",
    shortName: "VA",
  },
  {
    longName: "Washington",
    shortName: "WA",
  },
  {
    longName: "West Virginia",
    shortName: "WV",
  },
  {
    longName: "Wisconsin",
    shortName: "WI",
  },
  {
    longName: "Wyoming",
    shortName: "WY",
  },
  {
    longName: "District of Columbia",
    shortName: "DC",
  },
  {
    longName: "American Samoa",
    shortName: "AS",
  },
  {
    longName: "Guam",
    shortName: "GU",
  },
  {
    longName: "Northern Mariana Islands",
    shortName: "MP",
  },
  {
    longName: "Puerto Rico",
    shortName: "PR",
  },
  {
    longName: "United States Minor Outlying Islands",
    shortName: "UM",
  },
  {
    longName: "U.S. Virgin Islands",
    shortName: "VI",
  },
]

export const STATE_NAME_MAPPING = ALL_STATES.reduce(
  (acc, state) => ({
    ...acc,
    [state.shortName]: state.longName,
  }),
  {},
)

export const STATE_LONG_TO_SHORT = STATES.reduce(
  (acc, state) => ({
    ...acc,
    [state.longName]: state.shortName,
  }),
  {},
)

export const STATE_SHORT_TO_LONG: { [key: string]: string } = STATES.reduce(
  (acc, state) => ({
    ...acc,
    [state.shortName]: state.longName,
  }),
  {},
)

export const lessonTypes: { [key: string]: LessonType } = {
  // Note `oneHour` is used in IL only.
  oneHour: {
    name: LessonTypeName.OneHour,
    label: "1-hour behind-the-wheel lesson",
    filterLabel: "1-hour behind-the-wheel",
    durationMinutes: hoursToMinutes(1),
    stateMeta: {
      il: {
        doShowInPicker: true,
        features: [
          "The state's top driving instructors",
          "Lessons customized to your skill and comfort level",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
    },
  },
  shared: {
    name: LessonTypeName.Shared,
    label: "2-hour shared behind-the-wheel lesson",
    filterLabel: "2-hour shared behind-the-wheel",
    durationMinutes: hoursToMinutes(2),
    stateMeta: {
      tx: {
        title: "Teen 7x7",
        description:
          "For teens who purchased shared lessons (1x1, 7x7, or 11x7 package), where lessons are shared with other students as required by the state.",
        icon: <Group />,
        features: [
          "Certified instructors",
          "Each lesson customized specifically to your needs",
          "Meet a central location with your lesson partner",
          "We find you a lesson partner",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
        doShowInPicker: true,
      },
    },
  },
  oneHourShared: {
    name: LessonTypeName.OneHourShared,
    label: "1-hour shared behind-the-wheel lesson",
    filterLabel: "1-hour shared behind-the-wheel",
    durationMinutes: hoursToMinutes(1),
    stateMeta: {
      wa: {
        doShowInPicker: true,
        features: [
          "Certified instructors",
          "Each lesson customized specifically to your needs",
          "Meet a central location with your lesson partner",
          "We find you a lesson partner",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
        title: "Teen 5x1",
        description:
          "For teens who purchased the 5x1 package, where some lessons have an observer as required by the state.",
        icon: <Group />,
      },
    },
  },
  standard: {
    name: LessonTypeName.Standard,
    label: "2-hour behind-the-wheel lesson",
    filterLabel: "2-hour behind-the-wheel",
    durationMinutes: hoursToMinutes(2),
    stateMeta: {
      tx: {
        title: "Adult",
        description:
          "For those 18+ or teens who are looking for additional lessons. Does not count towards state-required 14 hours for teens.",
        icon: <Person />,
        features: [
          "Certified instructors",
          "Each lesson customized specifically to your needs",
          "Home pickup and drop off available",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        doShowInPicker: true,
      },
      ca: {
        doShowInPicker: true,
        features: [
          "DMV-certified instructors",
          "Six hours fulfills DMV requirements for driving instruction",
          "Each lesson customized specifically to your needs",
          "Home pickup and drop off available",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
      co: {
        doShowInPicker: true,
        features: [
          "Home pickup and drop off available",
          "DMV-certified instructors",
          "Six hours fulfills DMV requirements for driving instruction",
          "Each lesson customized specifically to your needs",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
      in: {
        doShowInPicker: true,
        features: [
          "The state's top driving instructors",
          "Lessons customized to your skill and comfort level",
          "BMV-licensed instructors",
          "Satisfaction guaranteed",
          "Fully accredited by the BMV",
        ],
        isDefaultLessonType: true,
      },
      mo: {
        doShowInPicker: true,
        features: [
          "Highly-trained instructors",
          "Each lesson customized specifically to your needs",
          "Home pickup and drop off available",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
      nv: {
        doShowInPicker: true,
        features: [
          "Highly-trained instructors",
          "Each lesson customized specifically to your needs",
          "Home pickup and drop off available",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
      pa: {
        doShowInPicker: true,
        features: [
          "Highly-trained instructors",
          "Each lesson customized specifically to your needs",
          "Home pickup and drop off available",
          "Save $25 or more on packages",
          "Satisfaction guaranteed",
        ],
        isDefaultLessonType: true,
      },
    },
  },
  "dmv-test": {
    name: LessonTypeName.DmvTest,
    label: "DMV road test lesson",
    filterLabel: "DMV road test",
    durationMinutes: hoursToMinutes(3),
    stateMeta: {
      ca: {
        doShowInPicker: true,
        description:
          "If you need a car for your test, this service is for you. Not only will you have use of a Coastline car, but your instructor will do an extra hour of preparation with you before your test.",
        features: [
          "Pickup from home or work, up to 15 miles from the DMV",
          "A 1-hour test prep lesson with a certified instructor",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Call our support team before booking your test with the DMV so we can match availability",
          "Our support team is available any time to answer any questions",
        ],
      },
      nv: {
        doShowInPicker: true,
        description:
          "If you need a car for your test, this service is for you. Not only will you have use of a Coastline car, but your instructor will do an extra hour of preparation with you before your test.",
        features: [
          "Pickup from home or work, up to 15 miles from the DMV",
          "A 1-hour test prep lesson with a certified instructor",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Call our support team before booking your test with the DMV so we can match availability",
          "Our support team is available any time to answer any questions",
        ],
      },
    },
  },
  "road-test": {
    name: LessonTypeName.RoadTest,
    label: "30-Minute Road Test",
    filterLabel: "Road test",
    durationMinutes: hoursToMinutes(0.5),
    stateMeta: {
      co: {
        description:
          "Our road skills test is administered by a certified instructor and follows a pre-determined, state-approved route that will test your ability to drive safely and effectively. For those under 18, to be road test eligible you must have had your permit for at least one year, and must have completed 6 hours of behind the wheel instruction prior to taking your road test.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
        doShowInPicker: false,
      },
      tx: {
        title: "Road Test",
        icon: <Person />,
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Use a Coastline car for the test",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
        onlyService: ["road-tests"],
        additionalContentId: "texas-skills-test-information",
        doShowInPicker: false,
      },
      il: {
        title: "Road Test",
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
        doShowInPicker: false,
        onlyService: ["road-tests"],
      },
      in: {
        title: "Road Test",
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Insurance included",
          "Use a Coastline car for the test",
          "Our support team is available any time to answer any questions",
        ],
        doShowInPicker: false,
        onlyService: ["road-tests"],
      },
    },
  },
  "road-test-15": {
    name: LessonTypeName.RoadTest15,
    label: "15-Minute Road Test",
    filterLabel: "Road test",
    durationMinutes: 15,
    stateMeta: {
      pa: {
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test is available for a fee",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
      },
    },
  },
  "road-test-with-car": {
    name: LessonTypeName.RoadTestWithCar,
    label: "30-Minute Road Test With Coastline Car",
    filterLabel: "Road tests with Coastline car",
    durationMinutes: hoursToMinutes(0.5),
    stateMeta: {
      co: {
        description:
          "Our road skills test is administered by a certified instructor and follows a pre-determined, state-approved route that will test your ability to drive safely and effectively. For those under 18, to be road test eligible you must have had your permit for at least one year, and must have completed 6 hours of behind the wheel instruction prior to taking your road test.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
      },
      il: {
        title: "Road Test",
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
        doShowInPicker: false,
        onlyService: ["road-tests"],
      },
    },
  },
  "road-test-15-with-car": {
    name: LessonTypeName.RoadTest15WithCar,
    label: "15-Minute Road Test With Coastline Car",
    filterLabel: "Road tests with Coastline car",
    durationMinutes: 15,
    stateMeta: {
      pa: {
        description:
          "Our road skills test is administered by a certified instructor, starting and ending at our office.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test is available for a fee",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
      },
    },
  },
  "prep-test-60": {
    name: LessonTypeName.PrepTest60,
    label: "Road Skills Test Prep + Road Test",
    durationMinutes: 60,
    filterLabel: "Prep + Test",
    stateMeta: {
      tx: {
        doShowInPicker: true,
        title: "Prep + Road Test",
        icon: <Person />,
        description:
          "Get the prep you need with DPS-certified examiner, and then take your road skills test, all in one session.",
        features: [
          "Private lesson with a certified instructor",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Includes approved Texas road skills test",
        ],
        onlyService: ["road-tests"],
        additionalContentId: "texas-skills-test-information",
      },
    },
  },
  "road-test-120": {
    name: LessonTypeName.RoadTest120,
    label: "Road Test at PennDOT",
    durationMinutes: 120,
    filterLabel: "Road test",
    stateMeta: {
      pa: {
        doShowInPicker: true,
        title: "Road Test",
        description: "Use our car for your PennDOT road test.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
      },
    },
  },
  "road-test-180": {
    name: LessonTypeName.RoadTest180,
    label: "Test Prep + Road Test at PennDOT",
    durationMinutes: 180,
    stateMeta: {
      pa: {
        doShowInPicker: true,
        title: "Road Test",
        description:
          "An hour of test-focused practice and then use our car for your PennDOT road test.",
        features: [
          "Meet at one of our convenient locations",
          "Use of a Coastline car for the test",
          "Insurance included",
          "Our support team is available any time to answer any questions",
        ],
      },
    },
  },
}

type StateMarketing = Record<
  string,
  { landingPageIntro: string; alternateIntro?: string }
>

export const stateMarketing: StateMarketing = {
  generic: {
    landingPageIntro:
      "Learn to drive with Coastline and gain the skills and confidence you need for life, whether you're a first-time driver or need a refresher before your test.",
    alternateIntro:
      "Coastline Academy is the only national drivers ed program giving students step-by-step guidance on how to successfully learn to drive.",
  },
  ca: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up before your test, we offer driving education in California that will make you a safer, more confident driver for life.",
  },
  co: {
    landingPageIntro:
      "Home pickup and drop off available! We offer driving lessons across Colorado that will make you a safer, more confident driver for life.",
  },
  il: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up before your test, we offer driving education in Illinois that will make you a safer, more confident driver for life.",
  },
  in: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up before your test, we offer driving education in Indiana that will make you a safer, more confident driver for life.",
  },
  mo: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up on your skills, we offer driving education that will make you a safer, more confident driver for life.",
  },
  nv: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up on your skills, we offer driving education that will make you a safer, more confident driver for life.",
  },
  pa: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up on your skills, we offer driving education that will make you a safer, more confident driver for life.",
  },
  tx: {
    landingPageIntro:
      "Whether it's your first time behind the wheel or you need a brush up before your test, we offer driving education that will make you a safer, more confident driver for life.",
  },
}

export const baseAddressNotice = `Add your address in the "Bio & Settings" tab under "Base Address",
  and we will use that address by default when creating your availability.`

type PartnerDetails = {
  name: string
  logoId: string
  header?: string
}

export const PARTNER_DETAILS: Record<string, PartnerDetails> = {
  aceable: {
    name: "Aceable",
    logoId: "logos/aceable-logo_dn85nq",
  },
  driversed: {
    name: "DriversEd.com",
    logoId: "logos/drivers-ed-com-logo_qhhswd",
  },
  idrivesafely: {
    name: "iDriveSafely",
    logoId: "logos/idrive-safely-logo_gwm1ao",
  },
  zutobi: {
    name: "Zutobi",
    logoId: "logos/zutobi-logo_hqcjts",
    header: "Driving Lessons for Zutobi Students",
  },
}
